<template>
    <div
      class="cell-renderer-download-border icon-wrapper"
      :class="iconClass"
      :style="wrapperStyle"
      @click="clicked"
    >
      <font-awesome-icon class="download-icon" :icon="[iconType, icon]" />
      <span style="margin-left:5px;">{{displayName}}</span>
    </div>
</template>

<script>
export default {
  name: 'CellRendererDownloadBorder',
  computed: {
    icon () {
      return this.params.icon || '';
    },
    iconType () {
      return this.params.iconType || '';
    },
    iconColour () {
      return this.params.iconColour || '';
    },
    iconBackground () {
      return this.params.iconBackground || '';
    },
    iconBorder () {
      return this.params.iconBorder || '';
    },
    iconSize () {
      return this.params.iconSize || '';
    },
    displayName () {
      return this.params.displayName || '';
    },
    iconClass() {
      return this.params.value ? 'cursor-pointer' : 'disabled';
    },
    wrapperStyle() {
      return {
        color: this.iconColour,
        backgroundColor: this.hexToRgba(this.iconBackground, 0.1),
        border: `1px solid ${this.iconBorder}`,
        fontSize: this.iconSize,
      };
    }
  },
  methods: {
    clicked() {
      const { value, documentType, documentTypeId } = this.params;
      let commercialProductPK = this.params.data.ID;

      if (!value) {
        return;
      }

      const params = {
        documentType: documentType,
        documentGuid: [value],
        documentTypeId: documentTypeId,
        CommercialProductPK: commercialProductPK,
      };

      this.$parent.$emit('download', params);
    },
    hexToRgba(hex, alpha) {
      let r = 0, g = 0, b = 0;
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
  }
}
</script>

<style lang="scss">
  .cell-renderer-download-border {
    &.icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 15px;
      padding: 2.5px 8px;
    }
      
    &.disabled {
      opacity: 0.5;
    }
  }
</style>
